/**
 *  @samsung.com, @partner.Samsung.com, @partner.sec.co.kr 도메인만 허용
 *
 */
const isEmailDomainAllowed = function (email) {
    if(email === undefined || email === null || email === '') {
        return false
    }
    let allowedDomains = ['samsung.com', 'partner.Samsung.com', 'partner.sec.co.kr', 'etners.com'];
    let matches = email.match(/@(\w+(?:\.\w+)+)$/); // 이메일 도메인 추출

    if (matches) {
        let domain = matches[1];
        return allowedDomains.includes(domain);
    }

    return false;
}

const getEmailDomainAllowedMsg = function (target) {
    return `<p>유효하지 않는 메일 형식입니다. ${target} 메일 주소를 확인하세요.<br><br>` +
        `메일 주소는 3가지만 가능합니다.<br>` +
        `<span class='forg'>- 영소문, 숫자, _, . + @samsung.com</span><br>` +
        `<span class='forg'>- 영소문, 숫자, _, . + @partner.samsung.com</span><br>` +
        `<span class='forg'>- 영소문, 숫자, _, . + @partner.sec.co.kr</span><br></p>`
}

/**
 * xx(x)-xxx(x)-xxxx 형식만 허용
 *
 */
const isTelNum = function (telNum) {
    if(telNum === undefined || telNum === null || telNum === '') {
        return false;
    }
    if(!/^[0-9]{2,3}-?([0-9]{3,4})-?([0-9]{4})/.test(telNum)){
        return false;
    }
    return true;
}

/**
 * 전달 받은 인자가 운송장 번호(영어, 숫자만 허용) 인지 체크
 *
 */
const isBlNo = function (blNo) {
    if(blNo === undefined || blNo === null || blNo === '') {
        return false;
    }

    if (/^[A-Za-z0-9]+$/.test(blNo.trim())) {
        return true
    } else {
        return false
    }
}

/**
 * 전달 받은 인자가 허용되는 사번인지 체크
 * (영어, 숫자만 허용)
 *
 */
const isValidSabun = function (sabun) {
    if(sabun === undefined || sabun === null || sabun === '') {
        return false;
    }

    if (/^[A-Za-z0-9]+$/.test(sabun.trim())) {
        return true
    } else {
        return false
    }
}

/**
 * 전달 받은 인자가 정수값(양수, 공백x ,소수점x) 인지 체크
 *
 */
const isPositiveInteger = function (value) {
    const pattern = /^[1-9]\d*$/

    if (value === '') {
        return false
    }

    if (pattern.test(value)) {
        return true
    } else {
        return false
    }
}

export default {
    isEmailDomainAllowed,
    getEmailDomainAllowedMsg,
    isTelNum,
    isBlNo,
    isValidSabun,
    isPositiveInteger
}
